import { PermissionEnum, PROGRESS_STATUSES } from 'symbols';

/** Describes user access state model. */
export interface AccessStateModel {
  loadRolesStatus: PROGRESS_STATUSES;
  roles: PermissionEnum[];
}

/** Default data for access state initialization & reset. */
export const DEFAULT_ACCESS_STATE: AccessStateModel = {
  loadRolesStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  roles: []
};
